<template>
<div id="container">
   <div class="locationWrap about">
     <div>
       <span class="inner aniBox type_right gogo"><span>D</span>ata <br><span>A</span>nalysis <br><span>M</span>arketplace for <br><span>D</span>ata<br><span>A</span>lliance</span>
       <strong class="inner locTit aniBox type_bot gogo">
         <p class="">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</p>DAMDA 소개
       </strong>
     </div>
   </div>
   <div class="contents" >
     <div class="inner">
       <div class="subTitWrap aniBox type_left gogo">
         <h2>지원서비스</h2>
       </div>

       <div class="mcSec con_aboutService_01" id="about0201">
         <div class="inner">
           <div class="mainTit aniBox type_bot gogo">
             <h2>분석포털</h2>
             <p>빅데이터 분석 전문가 부재로 데이터 분석·활용에 어려움이 있는 기업 대상으로<br><strong>분석 모델링 개발, 검증 및 분석결과 시각화를 제공하여</strong><br>기업의 업무 프로세스 및 사용자 서비스를 개선하도록 지원합니다.</p>
           </div>
           <center style="margin-top: -30px;"><img src="/static/images/contents/img_aboutService_01.png" alt="" style="width: 100%; max-width: 1200px;"/></center>
           <div class="aboutService_01_con  aniBox type_bot gogo">
             <div class="item_1">
               <strong>분석 활용 서비스</strong>
               <p>▒&nbsp;&nbsp;공동플랫폼 운영 및 지원 정책 수립<br>▒&nbsp;&nbsp;데이터를 이용한 마이닝 모델 개발<br>▒&nbsp;&nbsp;비정형 데이터 분석 모델 개발</p>
             </div>
             <div class="item_2">
               <strong>상시지원 체계</strong>
               <p>▒&nbsp;&nbsp;데이터 분석·활용 상시지원 체계 구축 (전담인력 배치)<br>▒&nbsp;&nbsp;수요기업 협의체 구축 (기업협의체)</p>
             </div>
             <div class="item_3">
               <strong>지속가능 모델</strong>
               <p>▒&nbsp;&nbsp;수요기업간 협업 및 정보공유 커뮤니티</p>
             </div>
           </div>
         </div>
       </div>
     </div>

     <div class="mcSec con_aboutService_02" id="about0202">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>Open API</h2>
           <p>IoT 가전 빅데이터 공동 플랫폼(이하 ‘공동 플랫폼‘)으로 수집된 데이터는 물론, 분석 플랫폼을 통해 가공된 데이터에 대하여 가전/전자기업에서 활용할 수 있도록 Open API 서비스를 제공하는 서비스입니다.</p>
           <center><img src="/static/images/contents/img_aboutService_02.png" alt="" style="width: 100%; max-width: 701px;"/></center>
         </div>
         <div class="aboutService_02_con aniBox type_bot gogo">
           <div class="item_1">
             <div class="icon_box"></div>
             <dl>
               <dt>Open API 기대효과</dt>
               <dd>◎ 별도의 데이터 수집 시스템 구축 없이 데이터를 수집/조회</dd>
               <dd>◎ 공동플랫폼에서 제공하는 데이터를 활용하여 새로운 고객 서비스를 제공</dd>
             </dl>
           </div>
           <div class="item_2">
             <div class="icon_box"></div>
             <dl>
               <dt>Open API 이용방법</dt>
               <dd>◎ 공동 플랫폼 포탈에 사용자 등록<br>- 공동 플랫폼 내부 시스템 연계를 통해 Open API 플랫폼(이하 ‘API플랫폼’)으로 사용자 정보 전달</dd>
               <dd>◎ 공동 플랫폼 포탈 로그인</dd>
               <dd>◎ API 플랫폼 링크 클릭<br>- 공동플랫폼과 API플랫폼 간 SSO 연동을 통한 자동 로그인</dd>
               <dd>◎ API 플랫폼 이용</dd>
             </dl>
           </div>
         </div>
       </div>
     </div>

     <div class="inner mcSec con_aboutService_03" id="about0203">
       <div class="mainTit aniBox type_bot gogo">
         <h2>제품연계</h2>
         <h3><span>D</span>ata <span>A</span>nalysis <span>M</span>arketplace for <span>D</span>ata <span>A</span>lliance</h3>
         <p>담다는 <strong>기업의 IoT제품 개발부터 데이터 비즈니스까지 지원하는 플랫폼</strong> 입니다.<br>빅데이터 기업협의회에 가입하시고 DAMDA에서 제공하는 지원을 받으세요.</p>
       </div>
       <div class="aboutService_03_wrap">
         <ul class="aboutService_03_list col3">
           <li class="col_item aniBox type_bot gogo con01">
             <p>DAMDA IoT</p>
             <p class="txtBottom">기술, 표준, 통신방식 등 제품 개발에 대한 애로사항을 해결 하도록 지원해 드립니다.<br>IoT 제품의 데이터를 분석하기 위한 데이터수집 방안을 제시합니다.</p>
           </li>
           <li class="col_item aniBox type_bot gogo con02">
             <p>DAMDA Analytics</p>
             <p class="txtBottom">빅데이터 분석을 위해서는 반드시 전문 분석가가 있어야 한다?! DAMDA는 실무자가 데이터를 분석할 수 있도록 분석도구와 포털 서비스를 제공합니다.<br>직관적 UI와 130종의 다양한 기본 분석함수를 제공하여 손쉬운 분석이 가능합니다.</p>
           </li>
           <li class="col_item aniBox type_bot gogo con03">
             <p>DAMDA Mobile</p>
             <p class="txtBottom">IoT 제품 모니터링 및 제어를 위한 통합 앱을 지원합니다.<br>기업에서 자체 앱을 구현할 수 있도록 템플릿 앱을 지원하여 앱 개발 비용을 절감할 수 있습니다.</p>
           </li>
         </ul>
       </div>
     </div>

     <div class="mcSec con_aboutService_04" id="about0204">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>모바일 템플릿</h2>
           <p><span>담다 플랫폼 연동 기능이 포함된 IoT 제품을 판매하는 제조사에서 쉽게 IoT앱을 제작하여 고객에게 배포할 수 있도록 제공하는 앱 소스입니다.</span> 템플릿 앱 소스에는 IoT앱에 필요한 기본 기능이 구현되어 있으므로 제조사는 템플릿 앱 소스를 기반으로 쉽고 빠르게 자사 고유의 앱을 제작할 수 있습니다.</p>
         </div>
         <div class="aboutService_04_wrap">
           <h3>템플릿을 이용한 앱 개발 절차</h3>
           <ul class="aboutService_04_list col4">
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_03.png" alt="">
               </div>
               <p>1. 템플릿 앱 소스</p>
               <p class="txtBottom">- 자체 앱을 제작할 수 있는 기본 템플릿을 소스로 제공<br>- 자체 개발을 위한 검토</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_04.png" alt="">
               </div>
               <p>2. 개발 협의</p>
               <p class="txtBottom">- 담다 플랫폼 연동 협의<br>- 개발용 앱 연동서버 할당</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_05.png" alt="">
               </div>
               <p>3. 커스터 마이징</p>
               <p class="txtBottom">- 제품 브랜드에 따른 색상 및 디자인 조정<br>- 제품의 특화 기능 추가 개발 및 적용<br>- 컨텐츠 서비스, 고객지원 등 부가 기능 적용</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_06.png" alt="">
               </div>
               <p>4. 앱 등록 및 상용서비스</p>
               <p class="txtBottom">- 앱 심사 및 등록<br>- 상용서비스 제공</p>
             </li>
           </ul>
         </div>
         <div class="aboutService_04_wrap">
           <h3>템플릿 앱을 이용한 앱 개발의 특장점</h3>
           <dl>
             <dt>저비용으로 단기간 내에 앱 개발</dt>
             <dd>IoT 제품의 모바일 앱을 개발하려면 평균적으로 6개월 이상의 기간이 소요됩니다. <br>담다 플랫폼의 템플릿 앱은 기본적인 IoT 기능을 제공하기 때문에 앱 개발 기간을 획기적으로 단축할 수 있으며 추가 개발의 최소화를 통해 비용을 절약할 수 있습니다.</dd>
             <dt>담다 플랫폼을 활용한 안정적인 서비스 운영</dt>
             <dd>다양한 IoT 제품 연동을 지원하는 담다 플랫폼을 활용하면 자체 플랫폼 구축이 필요 없기 때문에 플랫폼 구축 비용을 절약할 수 있을 뿐만 아니라 안정적이고 지속 가능한 고객 서비스 제공이 가능합니다.</dd>
             <dt>앱 개발부터 등록까지 지원</dt>
             <dd>앱 서비스 경험이 없는 기업도 앱 템플릿을 이용하여 손쉽게 서비스를 제공할 수 있도록 개발부터 등록까지 필요한 모든 과정에 대한 교육서비스를 제공합니다.</dd>
           </dl>
         </div>
         <div class="aboutService_04_wrap">
           <h3>템플릿 앱 제공 기본 기능</h3>
           <ul class="aboutService_04_listBox col4">
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_07.png" alt="">
               </div>
               <p>회원 가입 및 로그인 기능</p>
               <p class="txtBottom">담다 플랫폼은 네이버, 카카오톡, 페이스북 및 담당 아이디 등록을 통한 회원 가입 기능을 제공합니다. <br>
                                     템플릿 앱은 회원 가입, 로그인, 아이디 및 비밀번호 찾기 등 모바일 앱 서비스를 위한 회원 기능을 포함하고 있습니다.</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_08.png" alt="">
               </div>
               <p>IoT 제품 등록 기능</p>
               <p class="txtBottom">모바일 IoT서비스를 위해서는 사용자가 보유한 IoT제품이 플랫폼에 등록되어야 합니다. <br>
                                     템플릿 앱은 Wi-Fi(SoftAP모드)를 통한 IoT제품 등록 기능을 제공합니다.</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_09.png" alt="">
               </div>
               <p>원격 상태 조회 및 제어 기능</p>
               <p class="txtBottom">템플릿 앱은 모바일 IoT 서비스의 핵심 기능인 IoT제품에 대한 원격 상태 조회 및 제어기능을 제공합니다. <br>
                                     간단한 설정 수정으로 기본 상태 조회 및 제어 서비스를 제공할 수 있습니다.</p>
             </li>
             <li class="col_item aniBox type_bot gogo">
               <div class="img_box aniBox type_cv delay01 gogo">
                 <img src="/static/images/contents/img_aboutService_10.png" alt="">
               </div>
               <p>푸시 알림 및 예약 제어 기능</p>
               <p class="txtBottom">담다 플랫폼은 IoT 제품에서 발생한 이벤트에 따른 알림메시지를 수신할 수 있는 푸시 알림 기능 및 지정된 요일과 시간에 원하는 제품을 자동 조작할 수 있는 예약 제어 기능을 제공합니다. <br>
                                     템플릿 앱은 푸시 알림 수신여부 지정 및 예약 제어를 설정할 수 있는 기능을 제공합니다.</p>
             </li>
           </ul>
         </div>
         <div class="aboutService_04_wrap">
           <h3>템플릿 앱을 이용한 앱 개발의 특장점</h3>
           <dl>
             <dd>담다 플랫폼에 가입한 사용자는 담다 공동 앱 뿐만 아니라 제조사 전용 IoT앱을 통해서 서비스를 받을 수 있습니다. <br>
                 제조사는 전용 앱을 통해서 담다 플랫폼의 IoT 제품 서비스 활용 뿐 아니라 제조사 고유의 특화 서비스를 더한 고품질 IoT 서비스를 제공할 수 있습니다.</dd>
           </dl>
           <center><img src="/static/images/contents/img_aboutService_11.png" alt="" style="width: 100%; max-width: 785px;"/></center>
         </div>
         <div class="btn_area taC aniBox type_top gogo">
           <router-link to="/download/template" class="btn_blue">모바일 템플릿 다운로드</router-link>
         </div>
       </div>
     </div>

     <div class="mcSec con_aboutService_05" id="about0205">
       <div class="inner">
         <div class="mainTit aniBox type_bot gogo">
           <h2>DAMDA SDK</h2>
           <p>DAMDA SDK는 가전사의 디바이스를 쉽고 빠르게 DAMDA 플랫폼과 연결할 수 있게 도와줍니다.<br>
               DAMDA SDK를 통해 가전사 기존 제품의 IoT화, IoT 신제품, 스타트업 기업의 IoT가전제품 등 IoT 제품 또는 솔루션을 고객 스스로가 혁신적으로 개발할 수 있습니다.</p>
         </div>
         <div class="aboutService_05_wrap">
           <h3>디바이스 to 서버 SDK</h3>
           <p>Embedded SDK<br>
               Android OS SDK<br>
               Linux OS SDK<br>
               Windows OS SDK
           </p>
           <center><img src="/static/images/contents/img_aboutService_12.jpg" alt="" /></center>
           <h3>서버 to 서버 SDK</h3>
           <p>Java Svr SDK<br>
               Asp Svr SDK
           </p>
           <center><img src="/static/images/contents/img_aboutService_13.jpg" alt="" /></center>
           <BR />
           <div class="btn_area taC aniBox type_top gogo">
             <router-link to="/download/sdk" class="btn_blue">SDK 다운로드</router-link>
           </div>

         </div>
       </div>
     </div>

     <div class="mcSec con_aboutService_06" id="about0206">
         <div class="inner">
           <div class="mainTit aniBox type_bot gogo">
             <h2>해외데이터 규제대응 지원</h2>
             <p>수출 주요국의 데이터 보안 규제에 선제적 대응으로 수출 기업의 리스크 관리를 지원합니다.</p>
           </div>
           <div class="aboutService_06_con aniBox type_bot gogo">
             <div class="item_1">
               <div class="icon_box"></div>
               <p>해외 데이터 규제 현황조사</p>
             </div>
             <div class="item_2">
               <div class="icon_box"></div>
               <p>해외 데이터 규제대응 지원 및 교육</p>
             </div>
           </div>
         </div>
       </div>

     <!-- rightBar -->
     <aside id="rightBar">
       <ul>
         <li class="on">
           <a href="#container">
             <span class="rightbar-bullet-txt"><em>지원서비스</em></span>
             <span class="bullet bullet-01"><i class="material-icons">apps</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0201">
             <span class="rightbar-bullet-txt"><em>분석포털</em></span>
             <span class="bullet bullet-02"><i class="material-icons">insert_chart</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0202">
             <span class="rightbar-bullet-txt"><em>Open API</em></span>
             <span class="bullet bullet-03"><i class="material-icons">format_shapes</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0203">
             <span class="rightbar-bullet-txt"><em>제품연계</em></span>
             <span class="bullet bullet-03"><i class="material-icons">devices</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0204">
             <span class="rightbar-bullet-txt"><em>모바일 템플릿</em></span>
             <span class="bullet bullet-03"><i class="material-icons">add_to_home_screen</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0205">
             <span class="rightbar-bullet-txt"><em>DAMDA SDK</em></span>
             <span class="bullet bullet-03"><i class="material-icons">archive</i></span>
           </a>
         </li>
         <li class="">
           <a href="#about0206">
             <span class="rightbar-bullet-txt"><em>해외데이터 규제대응 지원</em></span>
             <span class="bullet bullet-03"><i class="material-icons">language</i></span>
           </a>
         </li>
       </ul>
     </aside>
     <!-- //rightBar -->
   </div>
 </div>
</template>

<script>
export default {
  name: 'AboutService',
  data () {
    return {
      msg: 'DAMDA Admin에 오신 것을 환영합니다.'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AboutService.vue